require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/babel-polyfill/~/core-js/fn/regexp/escape.js
// module id = 1041
// module chunks = 0